import { Navigate,Route, Routes } from "react-router-dom";
import LoginPage from "./page/LoginPage";
import MainPage from "./page/MainPage";
import PdfPreviewer from "./page/PdfPreviewer";
import PdfPreviewerShow from "./page/PdfPreviewerShow";

let Box  = (p:{component:JSX.Element}) :JSX.Element=>{
  let token = sessionStorage.getItem("token")
  if(!token) return <Navigate to={'/'}/>
  return p.component
}

const App = () => {
  return (
      // <Routes>
      //   <Route path="/" Component={LoginPage}/>
      //   <Route path="/MainPage" Component={MainPage}/>
      //   <Route path="/PdfPreviewer" Component={PdfPreviewer}/>
      //   <Route path="/PdfPreviewerShow" Component={PdfPreviewerShow}/>
      // </Routes>
      <Routes>
        <Route path="/" element={<LoginPage/>}/>
        <Route path="/MainPage"  element={<Box component={<MainPage/>}/>} />
        <Route path="/PdfPreviewer" element={<Box component={<PdfPreviewer/>}/>}/>
        <Route path="/PdfPreviewerShow" Component={PdfPreviewerShow}/>
        {/* <Route path="*" element={<Navigate to="/" replace={true} />} /> */}
      </Routes>
  );
};

export default App;